import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const ContraseniaActualFormGroup = ({ iTouched, iError, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='Contraseña Actual' md={12} />
      <Col md={12}>
        <Field name='contrasenaActual'>
          {({ field }) => <Form.InputPassword id='contrasenia-actual' isInvalid={iError && iTouched} disabled={fIsSubmitting} {...field} />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ContraseniaActualFormGroup)
